import { services } from '../services';
var action = "accounting/binding";

export const accountbindingService = {
    getOne,
    update
};


function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}